/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CustomTalentAlertType {
  AVAILABILITY = "AVAILABILITY",
  ROLL_OFF = "ROLL_OFF",
}

export const CustomTalentAlertTypeDisplay: Record<CustomTalentAlertType, string> = {
  [CustomTalentAlertType.AVAILABILITY]: "AVAILABILITY",
  [CustomTalentAlertType.ROLL_OFF]: "ROLL_OFF",
};
